import experiments from '../../experiments';
import { isExperimentEnabled } from '../../user_context_helpers';
import { IUser } from '../user_context_provider';

export function shouldCountStaleListings(user: Partial<IUser>): boolean {
  return user?.countryCode === 'US' && isExperimentEnabled(user, experiments.COUNT_CSP_STALE_LISTINGS);
}

export function shouldHideStaleListings(user: Partial<IUser>): boolean {
  const countStaleListings = shouldCountStaleListings(user);
  const hideStaleListingsExpActive = isExperimentEnabled(user, experiments.HIDE_CSP_STALE_LISTINGS);

  return countStaleListings && hideStaleListingsExpActive;
}
